module.exports = __webpack_public_path__ + "static/media/35.8e83acb8.mp3";